import type { IntlShape } from '@atlassian/jira-intl';
import {
	COLUMN_CHANGE,
	ESTIMATION_CHANGE,
	ISSUE_ADDED,
	ISSUE_REMOVED,
	TRANSITION_TO_DONE,
	TRANSITION_TO_NOT_DONE,
	UNKNOWN_EVENT,
} from '../../../../common/constants';
import type { SprintScopeChangeData } from '../../../../common/types';
import messages from './messages';

type TooltipTextOptions = {
	intl: IntlShape;
	event: SprintScopeChangeData;
};

export const getTooltipText = ({ event, intl }: TooltipTextOptions): string => {
	switch (event.eventType) {
		case ESTIMATION_CHANGE:
			return `
                <b>${event.issueKey}</b>
                <br />
                ${intl.formatMessage(messages.estimationUpdated)}
            `;
		case TRANSITION_TO_DONE:
			return `
                <b>${event.issueKey}</b>
                <br />
                ${intl.formatMessage(messages.transitionToDone)}
            `;
		case TRANSITION_TO_NOT_DONE:
			return `
                <b>${event.issueKey}</b>
                <br />
                ${intl.formatMessage(messages.transitionToNotDone)}
            `;
		case ISSUE_REMOVED:
			return `
                <b>${event.issueKey}</b>
                <br />
                ${intl.formatMessage(messages.issueRemoved)}
            `;
		case ISSUE_ADDED:
			return `
                <b>${event.issueKey}</b>
                <br />
                ${intl.formatMessage(messages.issueAdded)}
            `;
		// These two last are other events, but if they get here it's because their issues did
		// change estimation.
		case COLUMN_CHANGE:
			return `
                <b>${event.issueKey}</b>
                <br />
                ${intl.formatMessage(messages.estimationUpdated)}
            `;
		case UNKNOWN_EVENT:
			return `
                <b>${event.issueKey}</b>
                <br />
                ${intl.formatMessage(messages.estimationUpdated)}
            `;
		default:
			return '';
	}
};
